<script setup lang="ts">
import { CloseOutlined } from '@ant-design/icons-vue'

defineOptions({
  name: 'DefaultName'
})

withDefaults(
  defineProps<{
    show?: boolean
  }>(),
  {
    show: false
  }
)
const emits = defineEmits(['close'])
</script>

<template>
  <div class="mobile-bottom__container" :class="{ show }">
    <div class="mobile-bottom__content">
      <a-button class="content-close" @click="emits('close')">
        <template #icon>
          <CloseOutlined />
        </template>
      </a-button>
      <slot />
    </div>
  </div>
</template>

<style lang="scss">
@use './styles.scss';
</style>
